import React from "react"
import { Location } from "@gatsbyjs/reach-router"
import { useDispatch } from "react-redux"
import { BaseDispatch } from "../../redux/store"
import { getRouteRedirect } from "../../constants/routeRedirects.js"

type LocationHandlerProps = {
  children: any
  location: Location
}

export default function LocationHandler({
  children,
  location,
}: LocationHandlerProps) {
  const dispatch = useDispatch<BaseDispatch>()
  const redirectTo = getRouteRedirect(location.pathname)

  React.useLayoutEffect(() => {
    if (redirectTo) {
      window.location.replace(redirectTo)
    }
  }, [redirectTo])

  React.useEffect(() => {
    if (redirectTo) return

    const handleFitHash = async () => {
      await dispatch.sidebar.setIsOpen(true)
      await dispatch.sidebar.setSideBarStep("fit")
    }

    if (location.hash === "#fit") {
      handleFitHash()
    }
  }, [location.hash, redirectTo, dispatch.sidebar])

  if (redirectTo) {
    return null
  }

  return children
}
